import { render, staticRenderFns } from "./Tasas.vue?vue&type=template&id=3a60676c"
import script from "./Tasas.vue?vue&type=script&lang=js"
export * from "./Tasas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports